var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{ 'error': _vm.sms_content_data.is_invalid }},[_c('span',[_vm._v(_vm._s(_vm.sms_content_data.stats)+" ")]),_c('span',[_vm._v(_vm._s(_vm.sms_content_data.number_of_segments))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }